<template>
  <div id="app">
    <router-view />
    <div class="loading" v-loading.fullscreen.lock="loading"></div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      getResult: 'nullData',
      loading: false,
    }
  },
  created() {
    this.$eventBus.$off('setLoading')
    this.$eventBus.$on('setLoading', res => {
      this.loading = res
    })
  },
}
</script>


<style lang="scss">
.handle-container {
  justify-content: start;
}
</style>
